module.exports = __webpack_public_path__ + "img/assistantAccount-crm-warp2-img5.c898b41a.png";